import React, { useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Wizard from "components/common/Wizard";
import { getValueFromInput } from "util/FormsUtils";
import Routes from "routing/Routes";
import StepAuthorize from "integrations/aws/StepAuthorize";
import { StepsContext } from "integrations/aws/context/Steps";
import FormDataContext from "integrations/contexts/FormDataContext";
import { ApiContext } from "integrations/aws/context/Api";
import { SidebarContext } from "integrations/aws/context/Sidebar";
import StepKinesis from "./StepKinesis";
import StepHealthCheck from "./StepHealthCheck";
import StepReview from "./StepReview";
import SidebarPermissions from "./SidebarPermissions";
const CloudWatch = ({ externalInputSubmit = false, onSubmit = void 0 }) => {
  const { availableSteps, currentStep, isDisabledStep, setAvailableStep, setCurrentStep, setEnabledStep } = useContext(StepsContext);
  const { setFormData } = useContext(FormDataContext);
  const { availableStreams } = useContext(ApiContext);
  const { sidebar, clearSidebar } = useContext(SidebarContext);
  const navigate = useNavigate();
  const handleStepChange = (nextStep) => {
    setCurrentStep(nextStep);
  };
  const wizardSteps = useMemo(() => {
    const handleEditClick = (nextStep) => () => {
      setCurrentStep(nextStep);
    };
    const handleFieldUpdate = ({ target }, fieldData) => {
      const id = target.name || target.id;
      let value = getValueFromInput(target);
      if (typeof value === "string") {
        value = value.trim();
      }
      setFormData(id, { ...fieldData, value });
    };
    const handleSubmit = (maybeFormData) => {
      clearSidebar();
      const nextStep = availableSteps.indexOf(currentStep) + 1;
      if (availableSteps[nextStep]) {
        const key = availableSteps[nextStep];
        setCurrentStep(key);
        setEnabledStep(key);
      } else if (externalInputSubmit) {
        onSubmit(maybeFormData);
      } else {
        navigate(Routes.SYSTEM.INPUTS);
      }
    };
    return [
      {
        key: "authorize",
        title: "AWS Kinesis Authorize",
        component: /* @__PURE__ */ React.createElement(
          StepAuthorize,
          {
            onSubmit: handleSubmit,
            onChange: handleFieldUpdate,
            sidebarComponent: /* @__PURE__ */ React.createElement(SidebarPermissions, null)
          }
        ),
        disabled: isDisabledStep("authorize")
      },
      {
        key: "kinesis-setup",
        title: "AWS Kinesis Setup",
        component: /* @__PURE__ */ React.createElement(StepKinesis, { onSubmit: handleSubmit, onChange: handleFieldUpdate, hasStreams: availableStreams.length > 0 }),
        disabled: isDisabledStep("kinesis-setup")
      },
      {
        key: "health-check",
        title: "AWS CloudWatch Health Check",
        component: /* @__PURE__ */ React.createElement(StepHealthCheck, { onSubmit: handleSubmit, onChange: handleFieldUpdate }),
        disabled: isDisabledStep("health-check")
      },
      {
        key: "review",
        title: "AWS Kinesis Review",
        component: /* @__PURE__ */ React.createElement(StepReview, { onSubmit: handleSubmit, onEditClick: handleEditClick, externalInputSubmit }),
        disabled: isDisabledStep("review")
      }
    ];
  }, [
    isDisabledStep,
    availableStreams.length,
    externalInputSubmit,
    setCurrentStep,
    setFormData,
    clearSidebar,
    availableSteps,
    currentStep,
    setEnabledStep,
    onSubmit,
    navigate
  ]);
  useEffect(() => {
    if (availableSteps.length === 0) {
      setAvailableStep(wizardSteps.map((step) => step.key));
    }
  }, [availableSteps, setAvailableStep, wizardSteps]);
  return /* @__PURE__ */ React.createElement(
    Wizard,
    {
      steps: wizardSteps,
      activeStep: currentStep,
      onStepChange: handleStepChange,
      horizontal: true,
      justified: true,
      hidePreviousNextButtons: true
    },
    sidebar
  );
};
export default CloudWatch;
